import { render, staticRenderFns } from "./breed_feedMethod_page.vue?vue&type=template&id=3fd5532e&scoped=true"
import script from "./breed_feedMethod_page.vue?vue&type=script&lang=js"
export * from "./breed_feedMethod_page.vue?vue&type=script&lang=js"
import style0 from "./breed_feedMethod_page.vue?vue&type=style&index=0&id=3fd5532e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd5532e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fd5532e')) {
      api.createRecord('3fd5532e', component.options)
    } else {
      api.reload('3fd5532e', component.options)
    }
    module.hot.accept("./breed_feedMethod_page.vue?vue&type=template&id=3fd5532e&scoped=true", function () {
      api.rerender('3fd5532e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/breed_feedMethod_page.vue"
export default component.exports